const {
  REACT_APP_IMAGE_KEY,
  REACT_APP_API_URL,
  REACT_APP_API_BASE,
  REACT_APP_STRIPE_KEY,
  REACT_APP_STRIPE_DOMAIN,
  REACT_APP_INACTIVITY_TIMEOUT,
  REACT_APP_LOGOUT_TIMEOUT,
  REACT_APP_CURRENCY_CODE,
  REACT_APP_REFRESH_TIME,
  REACT_APP_SALT,
  REACT_APP_MULTICLOUD_AWS_MOCK,
  REACT_APP_MULTICLOUD_AZURE_MOCK,
  REACT_APP_MULTICLOUD_DIGITAL_OCEAN_MOCK,
  REACT_APP_MULTICLOUD_GCP_MOCK,
  REACT_APP_MULTICLOUD_ORACLE_CLOD_MOCK,
} = process.env;

export const mockMulticloudAWS = REACT_APP_MULTICLOUD_AWS_MOCK === "true",
  mockMulticloudAzure = REACT_APP_MULTICLOUD_AZURE_MOCK === "true",
  mockMulticloudDO = REACT_APP_MULTICLOUD_DIGITAL_OCEAN_MOCK === "true",
  mockMulticloudGCP = REACT_APP_MULTICLOUD_GCP_MOCK === "true",
  mockMulticloudOracle = REACT_APP_MULTICLOUD_ORACLE_CLOD_MOCK === "true",
  saltCode = REACT_APP_SALT || "",
  currencyCode = REACT_APP_CURRENCY_CODE || "",
  logoutTimout = REACT_APP_LOGOUT_TIMEOUT,
  refreshTokenTime = REACT_APP_REFRESH_TIME,
  inaAcitvityTimeout = REACT_APP_INACTIVITY_TIMEOUT,
  stripeDomain = REACT_APP_STRIPE_DOMAIN || "",
  stripeSecret = REACT_APP_STRIPE_KEY || "",
  apiURL = REACT_APP_API_URL || "",
  basePath = REACT_APP_API_BASE || "api",
  imageKey = REACT_APP_IMAGE_KEY;
